<template>
  <!-- <div id="app" class="container-fluid vh-100 d-flex flex-column">
    <div
      v-if="refreshToken"
      class="alert alert-warning shadow-sm d-flex justify-content-between mt-3"
    >
      <span>You will be logged out shortly.</span>
      <a href="#renew" class="alert-link" @click.prevent="renew">
        Stay logged in?
      </a>
    </div> -->
  <router-view class="d-flex flex-column flex-fill" />
  <!-- </div> -->
</template>
<script>
export default {
  data: () => ({
    refreshToken: false
  }),
  methods: {
    renew() {
      this.$axios.get("/api/users/auth.json");
      this.refreshToken = false;
    }
  },
  created() {
    if (
      this.$store.getters.token &&
      this.$store.getters.token.exp > new Date() / 1000
    ) {
      setInterval(() => {
        const now = new Date() / 1000;
        const exp = this.$store.getters.token.exp;
        const timeLeft = exp - now;
        this.refreshToken = timeLeft < 90 && timeLeft > 5;
      }, 1000);
    }
  }
};
</script>
